import { render, staticRenderFns } from "./MenuTypeLayout.vue?vue&type=template&id=db807704"
import script from "./MenuTypeLayout.vue?vue&type=script&lang=js"
export * from "./MenuTypeLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports